import { instanceOfReference } from "@perxis-auto/shared/lib/lib/instanceOf";
import { selectors } from "../model/index.js";
const getPartiallyExtendedItems = (referencesState, items, options) => {
  const partiallyExtendedItems = [];
  const nonExtendedReferences = [];
  const uniqueNonExtendedReferences = /* @__PURE__ */ new Map();
  const { fields = [] } = options ?? {};
  for (const currentItem of items) {
    if (!currentItem.data) {
      continue;
    }
    const partiallyExtendedData = Object.entries(currentItem.data).reduce((partiallyExtendedItemData, [key, value]) => {
      const expandData = (data) => {
        const isReference = instanceOfReference(data);
        if (!isReference) {
          return data;
        }
        const referenceItem = selectors.selectById(referencesState, data.id);
        if (!referenceItem) {
          nonExtendedReferences.push(data);
          if (!uniqueNonExtendedReferences.has(data.id) && (!fields.length || fields.includes(key))) {
            uniqueNonExtendedReferences.set(data.id, data);
          }
          return data;
        }
        if (!referenceItem.data) {
          return data;
        }
        const displayName = referenceItem.data.alternateName || referenceItem.data.name;
        return {
          ...data,
          ...referenceItem.data,
          displayName
        };
      };
      let extendedValue;
      if (Array.isArray(value)) {
        extendedValue = value.map(expandData);
      } else {
        extendedValue = expandData(value);
      }
      return {
        ...partiallyExtendedItemData,
        [key]: extendedValue
      };
    }, currentItem.data);
    partiallyExtendedItems.push({
      ...currentItem,
      data: partiallyExtendedData
    });
  }
  return {
    partiallyExtendedItems,
    nonExtendedReferences,
    uniqueNonExtendedReferences: Array.from(uniqueNonExtendedReferences.values())
  };
};
export {
  getPartiallyExtendedItems
};
